import BaseConnector from './baseConnector';
import curveDownLeft from './curveDownLeft';
import curveDownLeftInverse from './curveDownLeftInverse';

export default class ConnectorProcess extends BaseConnector {
  draw() {
    const bottomOffset = 50;

    return `
      M ${this.topX} ${this.topY}
      L ${this.topX} ${this.bottomY - this.curveSize - bottomOffset}
      ${curveDownLeft(this.topX, this.bottomY - this.curveSize - bottomOffset, this.curveSize)}
      L ${this.bottomX + this.curveSize} ${this.bottomY - bottomOffset}
      ${curveDownLeftInverse(this.bottomX + this.curveSize, this.bottomY - bottomOffset, this.curveSize)}
      L ${this.bottomX} ${this.bottomY}
    `;
  }
}
